import { useState, useEffect, ReactNode } from "react";
import { DataContext } from "../../app/services/context";
import { getPages } from "../../app/utlis/api";

interface DataProviderProps {
    children: ReactNode;
}

const DataProvider = ({ children }: DataProviderProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);

        try {
                const res = await getPages();
            setData(res)
        } catch (err) {
            setError("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <DataContext.Provider value={{ data, loading, error, refetch: fetchData }}>
            {children}
        </DataContext.Provider>
    );
};

export default DataProvider